import { cn } from '@quadralize/utils'
import { AltArrowDown, AltArrowUp, Eye, Sort } from '@solar-icons/react'
import type { Column } from '@tanstack/react-table'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '../../overlays/dropdown-menu/dropdown-menu'
import { Button } from '../../ui/button/button'

interface DataTableColumnHeaderProps<TData, TValue> extends React.HTMLAttributes<HTMLDivElement> {
  column: Column<TData, TValue>
  title: string
}

export function DataTableColumnHeader<TData, TValue>({
  column,
  title,
  className,
}: DataTableColumnHeaderProps<TData, TValue>) {
  if (!column.getCanSort()) {
    return <div className={cn('outline-none', className)}>{title}</div>
  }

  return (
    <div className={cn('flex items-center gap-2 outline-none', className)}>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="sm" className="-ml-3 h-8 data-[state=open]:bg-bg-subtle">
            <span>{title}</span>
            {column.getIsSorted() === 'desc' ? (
              <AltArrowDown className="ml-2 h-4 w-4" focusable="false" />
            ) : column.getIsSorted() === 'asc' ? (
              <AltArrowUp className="ml-2 h-4 w-4" focusable="false" />
            ) : (
              <Sort className="ml-2 h-4 w-4" focusable="false" />
            )}
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start">
          <DropdownMenuItem onClick={() => column.toggleSorting(false)}>
            <AltArrowUp className="mr-2 h-3.5 w-3.5 text-text-tertiary/70" />
            Ascendente
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => column.toggleSorting(true)}>
            <AltArrowDown className="mr-2 h-3.5 w-3.5 text-text-tertiary/70" />
            Descendente
          </DropdownMenuItem>
          {column.getCanHide() && (
            <>
              <DropdownMenuSeparator />
              <DropdownMenuItem onClick={() => column.toggleVisibility(false)}>
                <Eye className="mr-2 h-3.5 w-3.5 text-text-tertiary/70" />
                Ocultar
              </DropdownMenuItem>
            </>
          )}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  )
}
